export const NewOrderAttributes = {
  Distribute: "distribute",
  ConsoleVisible: "consoleVisible",
  La1day: "la1day",
  La2day: "la2day",
  La3day: "la3day",
  La4day: "la4day",
  La5day: "la5day",
  La6day: "la6day",
  La7day: "la7day",
  La8day: "la8day",
  La9day: "la9day",
  La10day: "la10day",
  La11day: "la11day",
  La12day: "la12day",
  La13day: "la13day",
  La14day: "la14day",
  Day: "day",
  Retention: "retention",
} as const;

export type TNewOrderAttributes =
  (typeof NewOrderAttributes)[keyof typeof NewOrderAttributes];
